module.exports = __webpack_public_path__ + "img/logo_mini_dark.d23d357f.svg";